import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {useAtom} from "jotai";
import {pwd_value, refresh_button_show} from "@/atoms/common.ts";
import React, {useCallback, useEffect, useRef, useState} from "react";
import clsx from "clsx";
import st from "@/styles/LoginPage.module.scss";
import WritePwdFields from "@/ui/WritePwdFields.tsx";
import LoginLoader from "@/ui/LoginLoader.tsx";
import useAuth from "@/hooks/auth.ts";
import CommonClass from "@/utils/common.ts";
import DashboardClass from "@/utils/dashboard_class.ts";
import {getDeviceUUID} from "@/utils/export_functions.ts";
import {GoogleReCaptcha} from "react-google-recaptcha-v3";
import {login_data} from "@/atoms/profile.ts";
import LoginData from "@/types_and_interfaces/login_data.ts";
import {country_code} from "@/utils/constants.ts";
import {CheckPhoneData} from "@/types_and_interfaces/check_phone_data_interface.ts";
// import MainLoginForm from "@/pages/login/elemsV2/MainLoginForm.tsx";

import ArrowCircledIcon from "@/svg/ArrowCircledIcon.tsx";

const WritePinSecondStep:React.FC = () => {
    const {t} = useTranslation()
    const auth = useAuth()
    const navigate = useNavigate();
    // const queryParams = new URLSearchParams(location.search);

    const [pwd_fields] = useAtom(pwd_value);

    const formRef = useRef<any>(null)
    const effectRan = useRef<boolean>(false)
    const [reqLoad, setReqLoad] = useState<boolean>(false)
    const [error, setError] = useState(false)
    const [show_refresh] = useAtom(refresh_button_show)
    const uid = getDeviceUUID() || ""
    const savedPwd = localStorage.getItem("pwdFields");
    const savedUid = localStorage.getItem("uid");
    const [loginData] = useAtom(login_data)
    const data: LoginData = Boolean(loginData) ? JSON.parse(loginData) : {}

    const getCheckPhoneData = useCallback((): CheckPhoneData | null => {
        const stored = sessionStorage.getItem(CommonClass.local_storage_fields.check_phone_data);
        if (stored) {
            try {
                return JSON.parse(stored) as CheckPhoneData;
            } catch {
                return null;
            }
        }
        return null;
    }, [])

    const userId = getCheckPhoneData()?.user_id ?? ""

    const handleSetReqLoad = (event:any) => {
        const { value } = event.detail;
        setReqLoad(value);
    };

    const handleSetError = (event:any) => {
        const { value } = event.detail;
        setError(value);
    };

    const submitForm = async (e:React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        const pwd = pwd_fields.join("")

        if(typeof pwd === "string" && userId && uid) {

            if(show_refresh) {
                localStorage.setItem("pwdFields", pwd);
                localStorage.setItem("uid", uid);
                location.reload();
                setReqLoad(true)
                return
            }

            let is_login_page = false;

            Object.entries(DashboardClass.login_routes).forEach((obj) => {
                if (typeof obj[1] === "string" && window.location.href.includes(obj[1])) {
                    is_login_page = true;
                    return;
                }
            });

            if(is_login_page) {
                localStorage.setItem(CommonClass.local_storage_fields.login_kyc_checking_active, "true")
            }


            await auth.auth(pwd, userId, "scenario1")
        }
    }

    useEffect(() => {
        if(pwd_fields.length === 4) {
            let completed = true

            pwd_fields.map((x) => {
                if(x === "" || x === " ") {
                    completed = false
                }

            })

            if(completed && formRef.current) {
                formRef.current.requestSubmit()
            }
        }
    }, [pwd_fields]);

    useEffect(() => {

        if(savedPwd && savedUid) {
            setReqLoad(true)
        }

        if(!effectRan.current) {

            if(typeof userId !== "string" || (typeof userId === "string" && !userId.length)) {
                navigate(DashboardClass.login_routes.LoginStep1)
            }

            if(typeof data?.value !== "string" || (typeof data?.value === "string" && !data?.value.length)) {
                navigate(DashboardClass.login_routes.LoginStep1)
            }
        }

        window.addEventListener(CommonClass.CustomEvents.set_req_load, handleSetReqLoad)
        window.addEventListener(CommonClass.CustomEvents.set_err, handleSetError)

        return () => {
            effectRan.current = true
            window.removeEventListener(CommonClass.CustomEvents.set_req_load, handleSetReqLoad)
            window.removeEventListener(CommonClass.CustomEvents.set_err, handleSetError)
        }
    }, []);


    return (
        <div className={clsx(st.log_vars, st.secondary_second_step)}>
            {(savedPwd && savedUid) ? (
                <GoogleReCaptcha onVerify={() => {

                    auth.auth(savedPwd);
                    localStorage.removeItem("pwdFields");
                    localStorage.removeItem("uid");
                }

                } />
            ) : null}

            <form ref={formRef} className={st.other_steps} onSubmit={submitForm}>
                <div className={clsx(st.top, )}>

                    <div className={st.heading}>
                        <div className={st.welcome}>
                            <button
                                onClick={() => {
                                    navigate(DashboardClass.login_routes.LoginStep1)
                                }}
                            >
                                <ArrowCircledIcon />
                            </button>
                            {t("welcome_back")}
                        </div>

                        <div className={st.info}>
                            <span className={st.inf_text}>
                                {t("use_pin_for")} {country_code} {data?.value ?? ""}
                            </span>
                        </div>

                    </div>
                    <div className={clsx(st.form_core)}>

                        <WritePwdFields className={st.pin} error={error}/>

                    </div>

                </div>


                {reqLoad &&
                    <LoginLoader transparent/>
                }

            </form>

            {/*<MainLoginForm checkPhoneData={getCheckPhoneData()} />*/}
        </div>
    )
}
export default WritePinSecondStep
